export const _FilterResponseDataLead = (data) => {
  const lead = data?.data;

  if (!lead?.id || !lead?.attributes) {
    return { status: false };
  }

  return {
    status: true,
    data: {
      id: lead.id,
      attributes: {
        nome: lead.attributes.nome,
        sobrenome: lead.attributes.sobrenome,
        valor_consumo: lead.attributes.valor_consumo,
        email: lead.attributes.email,
        celular: lead.attributes.celular,
        tipo: lead.attributes.tipo,
        municipio: lead.attributes.municipio,
        uf: lead.attributes.uf,
        nome_concessionaria: lead.attributes.nome_concessionaria,
        usina: lead.attributes.usina,
        assessor: lead.attributes.assessor,
        campanha: lead.attributes.campanha,
        expires_time:lead.attributes.expires_time,
        origem_api: lead.attributes.origem_api,
        desconto_anual_previsto: lead.attributes.desconto_anual_previsto,
        desconto_usina: lead.attributes.desconto_usina,
        prazo_cancelamento_contrato_meses:
          lead.attributes.prazo_cancelamento_contrato_meses,
        prazo_contrato_meses: lead.attributes.prazo_contrato_meses,
        descricao_prazo_contrato: lead.attributes.descricao_prazo_contrato,
        text_prazo_implantacao: lead.attributes.text_prazo_implantacao,
        pipe_id: lead.attributes.pipe_id,
        sms_code: lead.attributes.sms_code,
        sms_confirmed: lead.attributes.sms_confirmed,
        attempts: lead.attributes.attempts,
        createdAt: lead.attributes.createdAt,
        updatedAt: lead.attributes.updatedAt,
      }
    },
  };
};
